import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'acorn-goal-check',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './goal-check.component.html',
  styleUrls: ['./goal-check.component.scss'],
})
export class GoalCheckComponent {
  @Output() close = new EventEmitter<void>();

  backToGoal(){
      this.close.emit();
  }
}
